import {
  RESPONSE_CAR_SHORT_INFO,
} from '../actions/carShortInfoActions'

import { states as queriesStates } from './queriesStates'

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  data: {}
}

const carShortInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_CAR_SHORT_INFO: {
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.READY,
          data: action.data
        }
      )
    }
    default:
      return state
  }
}

export default carShortInfoReducer
